export function htmlFeeInternal() {
  return (
    <>
      <hr />
      <h5>Taxas Internas (Plataforma)</h5>
      <p>
        Em nossa Plataforma, algumas transações estão sujeitas a taxas de
        funcionamento, administração e/ou parceria. Essas taxas variam de acordo
        com o tipo de Campanha contratada. Abaixo estão os principais tipos de
        taxas da plataforma que podem ser aplicadas:
      </p>

      <h4>1. Parceiro de Campanha</h4>
      <p>
        Esta modalidade de Campanha oferece um custo de aquisição inicial
        inferior as tradicionais onde as custas da Plataforma é recolhida
        gradualmente com o avanço da mesma, é uma opção para quem precisa manter
        recursos em mãos para a compra do produto da Campanha ou para quem não
        dispõe de fundos suficiente para adquirir a Campanha por já ter
        investido na aquisição do(s) Prêmio(s).
        <br />
        Neste caso os valores são debitados conforme os Tickets são vendidos e
        debitados no ato da aprovação da aquisição dos mesmos.
      </p>

      <h4>2. Mensalidade</h4>
      <p>
        Haverá a possibilidade, para Usuários que farão rifas com mais frequência, planos de Assinatura.
        <br />
        Em breve a tabela de custos estará disponível para análise.
      </p>

      <h4>3. Taxa de Saque</h4>
      <p>
        Estas taxas são recolhidas para suprir gastos administrativos de
        comunicação entre os Gateways de processamento de transações financeiras
        e a nossa Plataforma, são custos necessários para manter a Qualidade e
        Segurança em nossa Plataforma.
        <br />
        Em breve a tabela de custos estará disponível para análise.
      </p>

      <p>
        É importante verificar as condições e valores dessas taxas antes de
        realizar transações na Plataforma, temos uma equipe de Suporte preparada
        para sanar todas as suas dúvidas.
      </p>
    </>
  );
}
